import { fetchWithAuth, waitForAuthReady } from '../apiClient';

const VAPID_PUBLIC_KEY = 'BGyt9LsBZJylBH-AkkqJfZPkUcyhkECsjShTxEkgsHVt9DoXY5morXBi-JERUGXs26PEpunjJR0Gwt3kR886ugc';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * @typedef {Object} RegisterVapidOptions
 * @property {string | null | undefined} [deviceName]
 * @property {string | null | undefined} [deviceType]
 */

/**
 * Subscribe via VAPID and persist the subscription with metadata.
 * @param {RegisterVapidOptions} [options]
 */
export async function registerVapidSubscription(options = {}) {
  if (typeof window === 'undefined') {
    throw new Error('Notifications are not available in this environment.');
  }
  if (!('Notification' in window)) {
    throw new Error('Notifications are not supported by this browser.');
  }
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service workers are required for push notifications.');
  }

  await waitForAuthReady();

  const registration = await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }

  let payload;
  if (typeof subscription.toJSON === 'function') {
    payload = subscription.toJSON();
  } else {
    payload = {
      endpoint: subscription.endpoint,
      keys: subscription.keys || {},
    };
  }

  payload.deviceName = options.deviceName ?? null;
  payload.deviceType = options.deviceType ?? null;

  await fetchWithAuth('/api/subscriptions', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return subscription;
}

